import React from 'react';
import style from './style.scss'
import CheckboxGroup from './CheckboxGroup'

const Radio = (props) => {
    const {field} = props;

    return (<CheckboxGroup field={field} type="radio" />);
}

export default Radio;
